import { useEffect, useRef } from "react";

/**
 * useReveal — applies `.is-visible` to .reveal elements inside ref when they scroll into view.
 * One-shot: stops observing after revealing.
 */
export function useReveal(options) {
  const containerRef = useRef(null);

  useEffect(() => {
    const root = containerRef.current || document;
    const targets = root.querySelectorAll(".reveal");
    if (typeof IntersectionObserver === "undefined") {
      targets.forEach((el) => el.classList.add("is-visible"));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: "0px 0px -10% 0px", threshold: 0.08, ...(options || {}) },
    );
    targets.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, [options]);

  return containerRef;
}
